import { View, Text } from 'react-native-web';

import { ColorIndicator } from '../../../components';
import { TeamProps } from '../../../types';
import styles from './styles';

const TeamInfo = props => {
  const { team } = props;

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Team</Text>
      <View style={styles.row}>
        <View style={styles.infoBox}>
          <Text style={styles.label}>Name</Text>
          <Text>{team?.name}</Text>
        </View>
        <View style={styles.infoBox}>
          <Text style={styles.label}>Color</Text>
          <Text>
            {team?.color && <ColorIndicator color={team?.color?.hex} size="14px" />}
            {team?.color?.name}
          </Text>
        </View>
        <View style={styles.infoBox}>
          <Text style={styles.label}>Captain</Text>
          <Text>{team?.captain?.fullName}</Text>
          <Text>{team?.captain?.phone_number}</Text>
        </View>
      </View>
    </View>
  );
};

TeamInfo.propTypes = {
  team: TeamProps,
};

TeamInfo.defaultProps = {
  team: null,
};

export default TeamInfo;
